<template>
  <section class="form-section" :class="{collapsible: collapsible}">

    <header class="flex items-center justify-between clickable" @click="show = !show">
      <input @click.stop v-if="isTag" type="checkbox" :checked="allCategorySelected" @change="$emit('toggleSelectCategory')" style="margin-right: 14px;">
      <h4>{{resolvedTitle}}</h4>
      <strong v-if="count" class="number-of-tags">{{ `${count}` }}</strong>
      <span>
        <span
          v-if="collapsible"
          class="toggle teal-hover"
          :class="{closed: !show}"
        >
          <i class="far fa-chevron-down"/>
        </span>
        <i v-if="infoTooltip" data-tip class="fas fa-info-circle" v-tooltip="infoTooltip"></i>
      </span>
    </header>

    <collapse-transition>
      <div v-if="show">
        <slot/>
      </div>
    </collapse-transition>

  </section>
</template>

<script>
import collapseTransition from './CollapseTransition.vue'
export default {
  name: "CollapsibleFormSection",

  props: {
    collapsible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    translatableTitle: {
      type: String,
      default: ''
    },
    initShow: {
      type: Boolean,
      default: true
    },
    count: {
      type: String || Number || null,
      default: null
    },
    allCategorySelected: {
      type: Boolean,
      default: false
    },
    infoTooltip: {
      type: [String, Boolean],
      default: false
    }
  },

  created() {
    this.show = this.initShow
  },

  data() {
    return {
      show: true
    }
  },

  computed: {
    resolvedTitle() {
      if(this.translatableTitle && this.translatableTitle.length) return this.$t(this.translatableTitle)
      return this.title
    },

    isTag() {
      return this.count !== null
    },
  },

  components: {
    collapseTransition
  }
}
</script>

<style scoped>
  .number-of-tags {
    flex: 1;
    text-align: end;
    margin-right: 1rem;
    color: #FFA500;
  }

  .clickable{
    background-color: white;
    padding: 1rem;
    border-radius: 0.5rem;
  }

  .clickable:hover{
    cursor: pointer;
    background-color: rgb(251, 251, 251);
  }
</style>